import { render, staticRenderFns } from "./PluginManagement.vue?vue&type=template&id=d082f772&"
import script from "./PluginManagement.vue?vue&type=script&lang=js&"
export * from "./PluginManagement.vue?vue&type=script&lang=js&"
import style0 from "./PluginManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports